<div class="user-role-rule">
  <p class="rule-description">Enable this feature for users with specific roles.</p>

  <div class="common-user-roles">
    <h4>Common User Roles"></h4>
    <div class="user-role-chip-container">
      <div
        *ngFor="let role of commonItems"
        class="user-role-chip"
        [class.selected]="isItemSelected(role)"
        (click)="toggleItem(role)"
      >
        {{ role }}
      </div>
    </div>
  </div>

  <div class="user-role-input-container">
    <label for="user-role-input">Add Custom User Role:</label>
    <div class="input-group">
      <input
        type="text"
        id="user-role-input"
        [formControl]="newItemControl"
        placeholder="e.g., US Broker"
        (keydown.enter)="onInputKeydown($event)"
      />
      <button mat-flat-button color="primary" type="button" (click)="addItem()">Add</button>
    </div>
    <div *ngIf="error" class="error-message">{{ error }}</div>
  </div>

  <div class="user-roles-container" *ngIf="items.length > 0">
    <div class="user-roles-header">
      <h4>Selected User Roles ({{ items.length }})</h4>
      <button
        id="e2s-clear-all-user-roles"
        mat-button
        color="primary"
        type="button"
        class="fx--ml-sm"
        (click)="clearItems()"
      >
        Clear All
      </button>
    </div>

    <ul class="user-roles-list">
      <li *ngFor="let role of items; let i = index" class="user-role-item">
        <span class="user-role-name">{{ role }}</span>
        <button
          id="e2s-clear-all-user-roles_{{ index }}"
          mat-button
          color="primary"
          type="button"
          (click)="removeItem(i)"
          aria-label="Remove"
        >
          ×
        </button>
      </li>
    </ul>
  </div>

  <div class="empty-state" *ngIf="items.length === 0">
    <p>No User Roles selected. This feature will not be enabled for any role.</p>
  </div>
</div>
